import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Modal } from 'bootstrap/dist/js/bootstrap';

const ModalStyled = styled.div`
	background: rgba(0, 0, 0, 0.4);
`;

const IbanBox = styled.div`
	background: var(--bs-gray-100);
	border: 1px solid var(--bs-gray-300);
	border-radius: 6px;
	padding: 10px 14px;
	font-family: monospace;
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.5px;
	color: var(--bs-gray-900);
	text-align: center;
	word-break: break-all;
`;

function formatIbanGroups(iban) {
	if (!iban) return '';
	return iban.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim();
}

export default function ConfirmReplaceBankAccountModal({ bankAccount, onConfirm, onCancel }) {
	const modalRef = useRef(null);
	const actionRef = useRef('cancel');

	useEffect(() => {
		const modal = new Modal(modalRef.current, { backdrop: false });

		const hiddenEvent = () => {
			modal._element.removeEventListener('hidden.bs.modal', hiddenEvent);
			modal.dispose();
			document.body.style.overflow = 'auto';
			document.body.style.paddingRight = '0';
			if (actionRef.current === 'confirm') onConfirm();
			else onCancel();
		};

		modal._element.addEventListener('hidden.bs.modal', hiddenEvent);
		modal.show();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const hide = (action) => {
		actionRef.current = action;
		Modal.getInstance(modalRef.current)?.hide();
	};

	return (
		<ModalStyled className="modal" tabIndex="-1" ref={modalRef}>
			<div className="modal-dialog modal-md">
				<div className="modal-content">
					<div className="modal-header border-0 pb-0">
						<h5 className="modal-title">Nueva cuenta bancaria añadida</h5>
						<button type="button" className="btn-close" onClick={() => hide('cancel')} aria-label="Close"></button>
					</div>

					<div className="modal-body pt-2">
						<p className="text-muted small mb-3">
							Se ha guardado la siguiente cuenta bancaria:
						</p>
						<IbanBox>{formatIbanGroups(bankAccount.iban)}</IbanBox>
						{bankAccount.description &&
							<div className="text-center text-muted small mt-1">{bankAccount.description}</div>
						}
						<p className="mt-3 mb-0">
							¿Quieres configurarla como cuenta de cobro en alguna de las propiedades asociadas al propietario?
						</p>
					</div>

					<div className="modal-footer border-0 pt-0">
						<button
							type="button"
							className="btn btn-sm btn-light"
							onClick={() => hide('cancel')}
						>
							No, gracias
						</button>
						<button
							type="button"
							className="btn btn-sm btn-primary text-white"
							onClick={() => hide('confirm')}
						>
							Sí, configurar
						</button>
					</div>
				</div>
			</div>
		</ModalStyled>
	);
}
